<template>
  <section class="file-listing">
    <b-row>
      <b-col>
        <b-input-group>
          <template #prepend>
            <b-input-group-text>
              <v-icon icon="search"/>
            </b-input-group-text>
          </template>
          <b-input v-model="filter"/>
        </b-input-group>
      </b-col>
    </b-row>

    <b-card-group class="my-3"
                  columns>
      <file-card v-for="file in files"
                 @click.native="openFile(file)"
                 :key="file.id"
                 :file="file">
        <template slot="footer">
          <b-link @click.prevent.stop="destroy(file)"
                  href="#"
                  class="card-link text-danger">
            <v-icon icon="bin"/>
          </b-link>
        </template>
      </file-card>
    </b-card-group>

    <infinite-loading @infinite="fetchFiles"></infinite-loading>

    <b-modal
        @hide="closeFile"
        ref="modal"
        ok-only
    >
      <file-edit v-if="fileOpen"
                 :file="file"
                 @complete="reset"/>
    </b-modal>
  </section>
</template>

<script>
import axios from 'axios'
import FileEdit from './Edit'
import FileCard from './Card'
import InfiniteLoading from 'vue-infinite-loading'
import qs from 'qs'


export default {
  components: {FileEdit, InfiniteLoading, FileCard},
  data() {
    return {
      files: [],
      file: null,
      meta: null,
      filter: '',
      perPage: 25,
      fields: [
        {
          key: 'preview',
          label: " "
        },
        {
          key: 'file_name',
          label: 'Filename',
          sortable: true
        },
        {
          key: 'type',
          label: 'Type'
        },
        {
          key: 'actions',
          label: ' '
        }
      ]
    }
  },
  watch: {
    filter: 'reset'
  },
  computed: {
    fileOpen() {
      return !!(this.file)
    }
  },
  methods: {
    async reset() {
      this.files = []
      this.meta = null
      this.fetchFiles(function () {
      })
    },
    async fetchFiles($state) {
      try {
        let {data} = await axios.get('/api/files', {
          params: {
            page: (this.meta) ? this.meta.current_page + 1 : 1,
            limit: this.perPage,
            filter: {search: this.filter}
          },
          paramsSerializer: function (params) {
            return qs.stringify(params, {arrayFormat: 'repeat'})
          }
        })

        this.meta = data.meta
        this.files.push(...data.data)

        if (this.meta.current_page < this.meta.last_page) {
          $state.loaded()
        } else {
          $state.complete()
        }
      } catch (e) {
      }
    },

    /**
     * Delete a series
     * @param item
     */
    async destroy(item) {
      let confirmed = confirm('Are you sure?')
      if (!confirmed) return

      try {
        await axios.delete('/files/' + item.id)

        this.reset()
      } catch (ex) {
        alert('The file could not be deleted.')
      }
    },

    /**
     * Open the file
     * @param file
     */
    openFile(file) {
      console.log('here')
      this.file = file
      this.$refs.modal.show()
    },

    /**
     * Close the file
     */
    closeFile() {
      this.file = null
    },

    closeModal() {
      this.$refs.modal.hide()
    }
  }
}

</script>